"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = createCognitoIdentityClient;
var _clientCognitoIdentity = require("@aws-sdk/client-cognito-identity");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); if (r) { o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; }); } t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/**
 * Returns a CognitoIdentityClient with middleware
 * @param {CognitoIdentityClientConfig} config
 * @return {CognitoIdentityClient}
 */
function createCognitoIdentityClient(config) {
  var client = new _clientCognitoIdentity.CognitoIdentityClient({
    region: config.region
  });
  client.middlewareStack.add(function (next, _) {
    return function (args) {
      return next(middlewareArgs(args));
    };
  }, {
    step: "build",
    name: "cacheControlMiddleWare"
  });
  return client;
}
function middlewareArgs(args) {
  return _objectSpread(_objectSpread({}, args), {}, {
    request: _objectSpread(_objectSpread({}, args.request), {}, {
      headers: _objectSpread(_objectSpread({}, args.request.headers), {}, {
        "cache-control": "no-store"
      })
    })
  });
}